import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { ImageSettings } from './types'
import { $params } from '../../../../features/router'

export const submitCreateImageSettings = createEvent<ImageSettings>()

export const setImageSettingsForm = createEvent<ImageSettings>()

export const submitEditImageSettings = createEvent<ImageSettings>()

export const getImageSettingsMounted = createEvent()

export const createImageSettings = fx<ImageSettings, void>({
  method: 'POST',
  url: '/contest_image/bulk',
})

export const editImageSettings = fx<ImageSettings, void>({
  method: 'POST',
  url: '/contest_image/bulk',
})

export const getImageSettings = fx<void, ImageSettings>({
  method: 'GET',
  url: '/contest_image/array',
})

export const $imageSettings = restore(setImageSettingsForm, {
  cardWeb: '',
  cardApp: '',
  bannerWeb: '',
  bannerApp: '',
  winnersInfoBackgroundWeb: '',
  winnersInfoBackgroundApp: '',
  infoBackgroundWeb: '',
  infoBackgroundApp: '',
  vs: '',
  backgroundBigApp: '',
  backgroundBigWeb: '',
  backgroundMiddleApp: '',
  backgroundMiddleWeb: '',
  firstAvatarBigOriginApp: '',
  firstAvatarBigOriginWeb: '',
  firstAvatarBigGrayApp: '',
  firstAvatarBigGrayWeb: '',
  firstAvatarMiddleOriginApp: '',
  firstAvatarMiddleOriginWeb: '',
  firstAvatarMiddleGrayApp: '',
  firstAvatarMiddleGrayWeb: '',
  firstAvatarSmallOrigin: '',
  secondAvatarBigOriginApp: '',
  secondAvatarBigOriginWeb: '',
  secondAvatarBigGrayApp: '',
  secondAvatarBigGrayWeb: '',
  secondAvatarMiddleOriginApp: '',
  secondAvatarMiddleOriginWeb: '',
  secondAvatarMiddleGrayApp: '',
  secondAvatarMiddleGrayWeb: '',
  secondAvatarSmallOrigin: '',
})

export const $imagesSettingCreateStatus = restore<{
  isSuccess: boolean
}>(
  createImageSettings.doneData.map((a) => {
    return {
      isSuccess: true,
    }
  }),
  {
    isSuccess: false,
  },
)

sample({
  clock: submitCreateImageSettings,
  fn: (imageSettings) => {
    return {
      url: `/contest_image/bulk`,
      formData: { ...imageSettings },
    }
  },
  target: createImageSettings,
})

sample({
  clock: submitEditImageSettings,
  source: $params,
  fn: (params, imageSettings) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    return {
      url: `/contest_image/bulk`,
      formData: { ...imageSettings, contestId: id },
    }
  },
  target: editImageSettings,
})

sample({
  clock: getImageSettingsMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.demoContestID
    }
    return {
      url: `/contest_image/array?where={"contestId": ${id}}`,
    }
  },
  target: getImageSettings,
})

sample({
  clock: getImageSettings.doneData,
  fn: (doneData) => doneData.body,
  target: setImageSettingsForm,
})
